import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface RateUpdateConfirmStateIF {
  rate: string;
  merchantId: number;
}

const initialState = {
  rates: [] as RateUpdateConfirmStateIF[],
};

const RateUpdateConfirmSlice = createSlice({
  name: "RateUpdateConfirm",
  initialState,
  reducers: {
    updateRates: (
      state,
      action: PayloadAction<{
        rates: RateUpdateConfirmStateIF[];
      }>
    ) => {
      const { rates } = action.payload;
      state.rates = rates;
    },
  },
});

export const { updateRates } = RateUpdateConfirmSlice.actions;

export default RateUpdateConfirmSlice.reducer;
